import React from 'react'

export const BarTile = ({
  label,
  onClick
}: {
  label: string
  onClick?: () => void
}) => {
  return (
    <div
      className='f-p-h-040 f-p-v-020 f-c-ba-whi f-shadow-strong f-radius-card-large f-t-tbody BarTile'
      onClick={onClick}
      role='button'>
      {label}
    </div>
  )
}
